export const STARTUP_LISTING_PLAN_IDS = ["starter", "popular", "pro"] as const;

export type StartupListingPlanId = (typeof STARTUP_LISTING_PLAN_IDS)[number];

export type StartupListingFeatureIcon =
	| "visitors"
	| "color"
	| "newsletter"
	| "views"
	| "pin"
	| "match";

export type StartupListingFeature = {
	icon: StartupListingFeatureIcon;
	label: string;
};

export type StartupListingPlan = {
	id: StartupListingPlanId;
	priceUsd: number;
	featured: boolean;
	features: StartupListingFeature[];
};

export const STARTUP_LISTING_PLANS: StartupListingPlan[] = [
	{
		id: "starter",
		priceUsd: 29,
		featured: false,
		features: [{ icon: "visitors", label: "120K+ visitors" }],
	},
	{
		id: "popular",
		priceUsd: 199,
		featured: true,
		features: [
			{ icon: "visitors", label: "120K+ visitors" },
			{ icon: "color", label: "Custom color" },
			{ icon: "newsletter", label: "Newsletter" },
			{ icon: "views", label: "5x views boost" },
		],
	},
	{
		id: "pro",
		priceUsd: 499,
		featured: false,
		features: [
			{ icon: "visitors", label: "120K+ visitors" },
			{ icon: "color", label: "Custom color" },
			{ icon: "newsletter", label: "Newsletter" },
			{ icon: "views", label: "20x views boost" },
			{ icon: "pin", label: "Pinned 30 days" },
			{ icon: "match", label: "Buyer matching" },
		],
	},
];

export function getStartupListingPlan(
	id: string,
): StartupListingPlan | undefined {
	return STARTUP_LISTING_PLANS.find((plan) => plan.id === id);
}

export function getStartupListingPriceCents(id: StartupListingPlanId): number {
	const plan = getStartupListingPlan(id);
	return (plan?.priceUsd ?? 0) * 100;
}
